import React, { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { SAMLAuthProvider, signInWithPopup } from 'firebase/auth'
import { Box, Button, Heading, Message, Text } from '@workwhile/ui'
import { auth, useAuthContext } from 'components/auth'
import * as ROUTES from 'constants/routes'

const DEFAULT_SAML_PROVIDER_ID = 'saml.workwhile-employees'

export const Login = () => {
  const { isAuthenticated } = useAuthContext()
  const [error, setError] = useState<Error | null>(null)

  if (isAuthenticated) {
    return <Navigate to={ROUTES.LANDING} replace />
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    setError(null)
    try {
      const provider = new SAMLAuthProvider(DEFAULT_SAML_PROVIDER_ID)
      await signInWithPopup(auth, provider)
    } catch (err) {
      setError(err as Error)
    }
  }

  return (
    <Box width={[1, 400]} as="form" onSubmit={handleSubmit} m={32}>
      <Heading>Welcome to WorkWhile!</Heading>
      <Text>Use your WorkWhile Google account to sign in.</Text>
      <Button mt={3} width={150} type="submit">
        Sign In using SSO
      </Button>
      {error ? (
        <Message my={2} variant="error">
          {error.message}
        </Message>
      ) : null}
    </Box>
  )
}
